/**
 *  baseURL: "https://api.medusapayments.com/v1"
 *     baseURL: "http://localhost:8080/v1"
 *
 *  baseURL:
 */
import axios from "axios";

export function getAPIClient() {
  const api = axios.create({
    baseURL: "https://api.medusapayments.com/v1"
  });

  api.interceptors.request.use((config) => {
    return config;
  });

  return api;
}

export const api = getAPIClient();
